/**
 * @flow
 * @format
 */

export type ValidatorType = {
  regex?: RegExp
  lengthMin?: number
  allowEmpty?: boolean
}

const validate = (str: string, format: ValidatorType) => {
  if (str === undefined || str === null) return false

  const { regex, lengthMin, allowEmpty } = format

  if (allowEmpty && str.length === 0) {
    return true
  }

  if (regex) {
    return regex.test(str)
  }
  if (lengthMin !== undefined && lengthMin !== null) {
    return str.length >= lengthMin
  }

  return false
}

const defaultValidateTypes = {
  notEmptyString: { regex: /^(?!\s*$).+/ },
  mail: {
    regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
  },
  tel: {
    french: { regex: /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/ },
    i18n: { regex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s.0-9]*$/ },
    numberOnly: { regex: /^[0-9]+$/ },
  },
  postalCode: { regex: /^(?:[0-8]\d|9[0-8])\d{3}$/ },
  lengthMin: (lengthMin: number, allowEmpty = false) => ({ lengthMin, allowEmpty }),
  lengthMinRegex: (value: number) => ({ regex: new RegExp(`^(?!s*$).{${value},}$`) }),
  lengthMinMaxRegex: (min: number, max: number) => ({ regex: new RegExp(`^(?!s*$).{${min},${max}}$`) }),
  password: {
    /**
     * Length : 6 min
     */
    level1: { regex: /^(?!\s*$).{6,}$/ },
    level2: { regex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{7,}$/ },
  },
}

const Validator = {
  validate,
  defaultValidateTypes,
}

export default Validator
